export default __webpack_public_path__ + "static/media/profile.a510c2d6.png";